module.exports = __webpack_public_path__ + "static/media/star-empty.db4d9c19.svg";